import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useEnableDualChannel from '../../../../../../../../Hooks/useEnableDualChannel';
import StyledBox from './styles';

export default function Legend() {
  const enableDualChannel = useEnableDualChannel();
  const { t } = useTranslation();
  if (!enableDualChannel) return null;
  return (
    <>
      <Divider />
      <StyledBox>
        <Box>
          <GraphicEqIcon />
          <Typography variant="body1">{t('detections.fromClient.title')}</Typography>
        </Box>
        <Box>
          <GraphicEqIcon />
          <Typography variant="body1">{t('detections.fromAgent.title')}</Typography>
        </Box>
      </StyledBox>
    </>
  );
}
